<template>
  <v-card :loading="loading">
    <v-card-text>
      <v-form>
        <v-container>
          <fieldset>
            <v-row>
              <v-col cols="12" sm="5" md="5">
                <label class="custom-label">Class</label>
                <v-select @change="classSelected" v-model="data.class_name_id" :items="classes"
                  :error-messages="errors.class_name_id" label="Choose Class" placeholder="Choose Class" solo
                  single-line></v-select>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <label class="custom-label">Student</label>
                <v-autocomplete @change="studentSelected" v-model="data.student_id" :error-messages="errors.student_id"
                  :items="students" label="Choose Student" placeholder="Choose Student" solo item-text="full_name"
                  item-value="std_id" />
              </v-col>
              <v-col cols="2" v-if="has_siblings">
                <label class="custom-label">For Siblings</label>
                <v-btn color="primary" height="48px" @click="getSiblings">Siblings</v-btn>
              </v-col>
            </v-row>
            <v-row v-for="(textField, i) in date_groups" :key="i">
              <v-col cols="12" sm="5" md="5">
                <label class="custom-label">Start Date</label>
                <v-menu ref="menu" v-model="menu[i]" :close-on-content-click="false"
                  :return-value.sync="data.start_dates[i]" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="formatedStartDates[i]" :error-messages="errors.start_date" label="Choose Date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.start_dates[i]" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu[i] = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu[i].save(data.start_dates[i])">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="5" md="5">
                <label class="custom-label">End Date</label>
                <v-menu ref="menu2" v-model="menu2[i]" :close-on-content-click="false"
                  :return-value.sync="data.end_dates[i]" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="formatedEndDates[i]" label="Choose Date" :error-messages="errors.end_date"
                      prepend-icon readonly v-bind="attrs" v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" v-model="data.end_dates[i]" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2[i] = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2[i].save(data.end_dates[i])">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="2" v-if="i == 0">
                <label class="custom-label">Generate Invoice</label>
                <v-btn color="primary" height="48px" @click="generateInvoice">Generate</v-btn>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="i != 0">
                <v-btn style="margin-top: 21px" height="49px" @click="removeDateGroup(i)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn @click="addDateGroup">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="5">
                <label class="custom-label">Hours</label>
                <v-text-field v-model="data.total_hours" :error-messages="errors.total_hours" label="Number of hours"
                  placeholder="Number of hours" solo readonly></v-text-field>
              </v-col>
              <v-col cols="5">
                <label class="custom-label">Amount</label>
                <v-text-field v-model="data.amount" :error-messages="errors.amount" label="Amount" placeholder="Amount"
                  solo readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5">
                <label class="custom-label">Invoice Of Month</label>
                <v-select v-model="data.invoice_of_month" :items="months" :error-messages="errors.invoice_of_month"
                  label="Choose Month" placeholder="Choose Month" solo required single-line></v-select>
              </v-col>
            </v-row>
          </fieldset>
          <fieldset v-for="(sibling, index2) in siblings">
            <v-row key="index2">
              <v-col>
                <label class="custom-label">Student</label>
                <v-autocomplete v-model="data.siblings[index2]" readonly :items="siblings" label="Choose Student"
                  placeholder="Choose Student" solo single-line item-text="full_name" item-value="std_id" />
              </v-col>
              <v-col>
                <label class="custom-label">Total Hours</label><br />
                <!-- {{Object.keys(data.siblings_data).length}} -->
                <v-text-field v-if="Object.keys(data.siblings_data).length > 0"
                  :value="data.siblings_data[sibling.std_id].total_hours" :error-messages="errors.total_hours"
                  label="Number of hours" placeholder="Number of hours" solo readonly></v-text-field>
              </v-col>
              <v-col>
                <label class="custom-label">Amount</label><br />
                <!-- {{Object.keys(data.siblings_data).length}} -->
                <v-text-field v-if="Object.keys(data.siblings_data).length > 0"
                  :value="data.siblings_data[sibling.std_id].amount" :error-messages="errors.total_hours"
                  label="Number of hours" placeholder="Number of hours" solo readonly></v-text-field>
              </v-col>
            </v-row>
          </fieldset>
          <v-col cols="12" sm="12" md="12">
            <v-textarea solo label="Notes" v-model="data.notes"></v-textarea>
          </v-col>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" :loading="loading" @click="save" dark>Save</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  // import StudentSelectMixin from "../../mixins/studentSelect";
  import Form from "../../utils/form";
  import moment from "moment";
  export default {
    name: "StudentInvoiceForm",
    // mixins: [
    //     StudentSelectMixin
    // ],
    props: {
      id: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "Octobar",
          "November",
          "December",
        ],
        has_siblings: false,
        students: [],
        siblings: [],
        date_groups: [""],
        classes: [],
        loading: true,
        errors: {},
        data: {
          invoice_of_month: "",
          siblings_data: [],
          siblings: [],
          start_dates: [""],
          end_dates: [""],
          student_id: null,
          class_name_id: null,
          // end_date: null,
          // start_date: null,
          total_hours: 0,
          amount: 0,
          status: 1,
        },
        menu: [false],
        menu2: [false],
        student_joining: "Student joining date is 07-05-2020",
        status: [
          {
            value: 1,
            text: "UnPaid",
          },
          {
            value: 2,
            text: "Paid",
          },
        ],
        selected_class: null,
        formatedStartDates: [""],
        formatedEndDates: [""],
      };
    },
    methods: {
      generateInvoice: function() {
        this.countChange();
      },
      countChange: function() {
        var self = this;
        // this.data.start_dates.forEach(function(value,index,array){
        //     console.log(value)
        //     // console.log(value)
        //     // var fulldate = new Date(value);
        //     const [year, month, day] = value.split('-')
        //     var formated_date = `${day}-${month}-${year}`;
        //     // console.log(new Date(formated_date))
        //     // console.log(self.data.start_dates[index])
        //     // self.data.start_dates[index] = [year, month, day].join('-');
        // })
        // `this` points to the vm instance
        axios
          .post("calculate/invoice", {
            params: {
              start_dates: this.data.start_dates,
              end_dates: this.data.end_dates,
              siblings: (this.has_siblings) ? this.data.siblings : [] ,
              student: this.data.student_id,
              class: this.data.class_name_id,
            },
          })
          .then(response => {
            this.data.amount = response.data.amount;
            this.data.total_hours = response.data.total_hours;
            console.log(response.data.siblings_data);
            this.data.siblings_data = response.data.siblings_data;
          });
        return this.data.end_dates.length;
      },
      endDateSelected() {
        alert("ss");
      },
      getSiblings() {
        axios.get("get/siblings/" + this.data.student_id).then(response => {
          this.loading = false;
          if (response.data.length == 0) {
            this.siblings = [];
            Toast.fire({
              icon: "error",
              title: "No Siblings!",
            });
            return false;
          }
          if (response.data == "nil") {
            this.siblings = [];
            Toast.fire({
              icon: "error",
              title: "Class is not selected for one of the siblings!",
            });
            return false;
          }
          this.errors = {};
          // this.$router.replace({name: "Accounts"})
          this.siblings = response.data;
          var self = this;
          var test = [];
          response.data.forEach(function(value, index, arr) {
            console.log(value.std_id);
            // console.log(index)
            test.push(value.std_id);
            // console.log(arr);
          });
          console.log(test);
          this.data.siblings = test;
        });
      },
      addDateGroup() {
        this.date_groups.push("");
        this.menu.push(false);
        this.menu2.push(false);
      },
      removeDateGroup(index) {
        this.date_groups.splice(index, 1);
        this.menu.splice(index, 1);
        this.menu2.splice(index, 1);
        this.data.start_dates.splice(index, 1);
        this.data.end_dates.splice(index, 1);
      },
      getClasses() {
        //    alert('ss')
        axios.get(apiRoutes.classes.url, {}).then(response => {
          // console.log(response)
          this.classes = response.data.response.map(group => {
            return {
              text: group.class_name,
              value: group.class_id,
            };
          });
        });
      },
      // totalHoursChanged() {
      //     // console.log("asdsad")
      //     if (this.selected_class && parseInt(this.data.total_hours) > 0) {
      //         this.data.amount = parseFloat(this.selected_class.fare) * parseInt(this.data.total_hours)
      //     }
      // },
      classSelected(event) {
        this.has_siblings = false;
        this.siblings = [];
        // this.selected_class = this.$store.getters.classes.find(item => item.id === event)
        // console.log(event)
        axios
          .get("class/students", {
            params: {
              class_id: event,
            },
          })
          .then(response => {
            console.log(response);
            if (response.data.length == 0) {
              Toast.fire({
                icon: "error",
                title: "No Students in the selected Class!",
              });
              return false;
            }
            this.students = response.data;
            // this.loading = false
            // this.errors = {}
            // this.$router.replace({name: "Accounts"})
          });
      },
      studentSelected(event) {
        this.has_siblings = false;
        this.siblings = [];
        this.data.siblings_data = [];
        console.log(event);
        axios
          .get("student/selected", {
            params: {
              student_id: event,
            },
          })
          .then(response => {
            // console.log("response.data", response.data);
            // console.log("response.data.data", response.data.data);
            if (response.data.response.siblings.length > 0) {
              this.has_siblings = true;
            }
            this.loading = false;
            this.errors = {};
            // this.$router.replace({name: "Accounts"})
          })
          .catch(response => {
            // console.log(response)
            if (response.status === 400) {
              this.errors = response.data;
            }
            if (response.status === 433) {
              Toast.fire({
                icon: "error",
                title: "Please Select All Fields!",
              });
            }
            this.loading = false;
          });
      },
      update() {
        this.loading = true;
        let form = new Form({
          ...this.data,
        });
        form
          .patch(apiRoutes.accounts.invoices.students.url + this.id + "/")
          .then(response => {
            this.data = {
              class_name_id: null,
              student_id: null,
              start_date: null,
              end_date: null,
              total_hours: 0,
              amount: 0,
              invoice_of_month:null
            };
            this.loading = false;
            this.errors = {};
            // this.$router.replace({
            //   name: "Accounts",
            // });
          })
          .catch(response => {
            if (response.status === 400) {
              this.errors = response.data;
            }
            this.loading = false;
          });
      },
      create() {
        this.loading = true;
        let form = new Form({
          ...this.data,
        });
        form
          .post(apiRoutes.accounts.invoices.students.store)
          .then(response => {
            this.loading = false;
            this.errors = {};
            this.data.student_id=null;
            Toast.fire({
                icon: "success",
                title: "Invoice Generated Successfully",
              });
          })
          .catch(response => {
            // console.log(response)
            if (response.status === 400) {
              this.errors = response.data;
            }
            if (response.status === 433) {
              Toast.fire({
                icon: "error",
                title: "Please Select All Fields!",
              });
            }
            this.loading = false;
          });
      },
      save() {
        if (this.id !== null) {
          this.update();
        } else {
          this.create();
        }
      },
    },
    computed: {
      startDatesFormat: function() {
        return this.data.start_dates;
      },
      endDatesFormat: function() {
        return this.data.end_dates;
      },
    },
    watch: {
      startDatesFormat: function(val) {
        // watch it
        var self = this;
        console.log(this.formatedStartDates);
        val.forEach(function(value, index, array) {
          self.formatedStartDates[index] = moment(value).format("DD-MM-YYYY");
        });
      },
      endDatesFormat: function(val) {
        // watch it
        var self = this;
        console.log(this.formatedEndDates);
        val.forEach(function(value, index, array) {
          self.formatedEndDates[index] = moment(value).format("DD-MM-YYYY");
        });
      },
    },
    mounted() {
      this.getClasses();
      this.loading = false;
      // alert(this.id)
      if (this.id !== null) {
        this.loading = true;
        axios
          .get(apiRoutes.accounts.invoices.students.edit + this.id)
          .then(response => {
            this.loading = false;
            // console.log(response.data.start_date)
            // this.data.start_date = response.data.start_date
            (this.data.class_name_id = response.data.class_id),
              (this.data.student_id = response.data.student_id),
              (this.data.start_date = response.data.start_date),
              (this.data.notes = response.data.notes),
              (this.data.end_date = response.data.end_date),
              (this.data.total_hours = response.data.total_hours),
              (this.data.amount = response.data.amount),
              (this.data.status = response.data.student_invoice_status);
            this.old_student = {
              value: response.data.student.user_id,
              text: response.data.student.name,
            };
            this.selected_class = this.$store.getters.classes.find(
              item => item.id === response.data.class_name.id
            );
            this.students = [this.old_student];
            this.loading = false;
          });
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  fieldset {
    border: 0;
  
    &:not(:last-of-type) {
      border-bottom: 1px dashed #8898aa80;
      margin-bottom: 20px;
    }
  
    & legend {
      font: Bold 20px/25px Lato;
      color: #172b4d;
    }
  }
  </style>